import debounce from 'lodash/debounce';
import { initSmartHomeMobileSlider } from './product-plug-in-control-smart-home/product-plug-in-control-smart-home';
import YTPlayer from '../../scripts/components/YTPlayer';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';
import { initPlugInControlProduct } from '../../snippets/product-base-plug-in-control/product-base-plug-in-control';
import { runSmartSubnav } from '../../snippets/smart-subnav/smart-subnav';
import { setMaxHeightStyle } from '../../scripts/utils/setMaxHeightStyle';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

runSmartSubnav({
  intersectionThreshold: [0, 0.2],
  intersectionRatio: 0.2,
});

const initCollapsiblePluginControlTechSpecsMenu = () => {
  const setMaxHeightToEls = () => {
    setMaxHeightStyle(
      '[data-product-plug-in-control-tech-specs-collapsible-content]'
    );
  };

  window.addEventListener('load', setMaxHeightToEls);

  window.addEventListener('resize', debounce(setMaxHeightToEls, 50));
};

initPlugInControlProduct();
initSmartHomeMobileSlider();
YTPlayer.init();
initInstallationSlider();
initCollapsiblePluginControlTechSpecsMenu();
initCollapsibleRows();
